import { render, staticRenderFns } from "./manage-dhis2-diagnostic.html?vue&type=template&id=80dc9472&scoped=true&external"
import script from "./manage-dhis2-diagnostic.js?vue&type=script&lang=js&external"
export * from "./manage-dhis2-diagnostic.js?vue&type=script&lang=js&external"
import style0 from "./manage-dhis2-diagnostic.scss?vue&type=style&index=0&id=80dc9472&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80dc9472",
  null
  
)

export default component.exports